/**
 * マニフェスト 受渡確認票 別タブ表示前バリデーション
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/confirmation_slips/verifications`

const order_confirmation_slip_verification = {
  namespaced: true,
  actions: {
    show ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    }
  },
}

export default order_confirmation_slip_verification
